module.exports = __webpack_public_path__ + "img/printer.27845bb2.svg";